import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getInbox(params) {
	return client.get("pesan/list-pesan/inbox", {
		params: params,
	});
}

function getMessageSent(params) {
	return client.get("pesan/list-pesan/terkirim", {
		params: params,
	});
}

function getDraft(params) {
	return client.get("pesan/list-pesan/draft", {
		params: params,
	});
}

function getArchive(params) {
	return client.get("pesan/list-pesan/archive", {
		params: params,
	});
}

function getDetailMessage(params) {
	return client.get("pesan/list-pesan/detail", {
		params: params,
	});
}

function getAutocomplete(params) {
	return client.get("pesan/autocomplete", {
		params: params,
	});
}

function addMessage(params) {
	return client.post("pesan/tambah", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addMessageAdmin(params) {
	return client.post("pesan/admin/tambah", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteMessage(params) {
	return client.post("pesan/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function archiveMessage(params) {
	return client.post("pesan/arsip", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function readMessage(params) {
	return client.post("pesan/read", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getInbox,
	getMessageSent,
	getDraft,
	getArchive,
	getDetailMessage,
	getAutocomplete,
	addMessage,
	addMessageAdmin,
	deleteMessage,
	archiveMessage,
	readMessage
};